import api from "src/apis/api";

// Editor API for the configurable marketing homepage. Reads the raw content +
// media URLs; saves content and uploads media (multipart when files present).

export async function fetchHomepageContent() {
  const { data } = await api.get("/api/v1/homepage_content");
  return data; // { content, media, library, sections, preview }
}

// Save content + optional media. `media` = { hero_image, hero_side_image, ... }
// (File or null). `library` = [{ key, file }] for keyed service/testimonial
// images. When any file is present we send multipart; otherwise plain JSON.
export async function saveHomepageContent(content, { media = {}, library = [] } = {}) {
  const mediaEntries = Object.entries(media).filter(([, f]) => f instanceof File);
  const libraryEntries = library.filter((l) => l.file instanceof File);

  if (mediaEntries.length === 0 && libraryEntries.length === 0) {
    const { data } = await api.patch("/api/v1/homepage_content", { content });
    return data;
  }

  const form = new FormData();
  form.append("content_json", JSON.stringify(content));
  mediaEntries.forEach(([attr, file]) => form.append(attr, file));
  libraryEntries.forEach(({ key, file }) => {
    form.append("library_media[]", file);
    form.append("library_keys[]", key);
  });

  const { data } = await api.patch("/api/v1/homepage_content", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function removeHomepageMedia(attribute) {
  const { data } = await api.delete(`/api/v1/homepage_content/media/${attribute}`);
  return data;
}
